import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e46680f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchpage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_select, {
      ref: "pageSelect",
      value: _ctx.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      "show-search": "",
      allowClear: "",
      getPopupContainer: _ctx.getPopupContainer,
      placeholder: "请输入功能名称",
      style: {"width":"200px"},
      "default-active-first-option": true,
      "filter-option": false,
      "show-arrow": false,
      onSearch: _ctx.handleSearch,
      "not-found-content": null,
      onChange: _ctx.handleChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            value: item.name,
            label: item.name,
            key: item.name
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["value", "label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "getPopupContainer", "onSearch", "onChange"])
  ]))
}